let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3xt73")).then(() => parcelRequire('6sHk7'));